import { useEffect, useState } from 'react'
import { transformParam } from '../utils/util'

export function useTransformTestParameters (runId, params) {
  const [transformedParams, setTransformedParams] = useState([])
  const [transformingParams, setTransformingParams] = useState(false)

  useEffect(() => {
    if (params?.length > 0) {
      setTransformingParams(true)
      const transformParamsPromises = params.map((param) =>
        transformParam(param, runId, true)
      )

      Promise.all(transformParamsPromises).then((transformed) => {
        setTransformedParams(transformed)
        setTransformingParams(false)
      })
    }
  }, [runId, params])

  return { transformedParams, transformingParams }
}
